import {create} from 'zustand';
import {UseUploadedRefundFilesStore} from './types';
import {IFile} from '../../types';

const useUploadedRefundFilesStore = create<UseUploadedRefundFilesStore>(set => ({
	uploadedFiles: [],
	resetUploadedFiles: () => set({uploadedFiles: []}),
	setUploadedFiles: fn =>
		set(state => ({
			uploadedFiles: fn(state.uploadedFiles),
		})),
	updateFile: (attachmentId: string, data: Partial<IFile>) =>
		set(state => ({
			uploadedFiles: state.uploadedFiles.map(file =>
				file.id === attachmentId ? {...file, ...data} : file,
			),
		})),
	addFiles: (newFiles: IFile[]) =>
		set(state => ({
			uploadedFiles: [...state.uploadedFiles, ...newFiles],
		})),
	removeFile: (attachmentId: string) =>
		set(state => ({
			uploadedFiles: state.uploadedFiles.filter(file => file.id !== attachmentId),
		})),
	removeFilesWithError: () =>
		set(state => ({
			uploadedFiles: state.uploadedFiles.filter(file => file.error === false),
		})),
}));

export {useUploadedRefundFilesStore};
